function initialize() {

    const sectionIds = ['inicio', 'o-programa', 'nossos-projetos', 'resultados', 'conteudos'];

    // Enquanto true, o listener de scroll não recalcula o link ativo,
    // evitando que "Início" pisque na tela durante o scroll suave até a seção clicada
    let isProgrammaticScroll = false;
    let scrollEndFallbackTimer = null;

    // Função para fazer scroll suave para uma seção
    const scrollToSection = (sectionId) => {
        const targetElement = document.getElementById(sectionId);
        if (targetElement) {
            const navElement = document.querySelector('.procampo-internal-nav');
            const navHeight = navElement?.offsetHeight || 0;
            const headerHeight = 135; // altura do header principal + padding
            const headerOffset = headerHeight + navHeight + 20;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            setActiveSection(sectionId);
            isProgrammaticScroll = true;

            window.scrollTo({
                top: Math.max(0, offsetPosition),
                behavior: 'smooth'
            });

            const finishProgrammaticScroll = () => {
                clearTimeout(scrollEndFallbackTimer);
                isProgrammaticScroll = false;
                updateActiveLink();
            };

            window.addEventListener('scrollend', finishProgrammaticScroll, { once: true });
            // Fallback para navegadores sem suporte a 'scrollend'
            clearTimeout(scrollEndFallbackTimer);
            scrollEndFallbackTimer = setTimeout(finishProgrammaticScroll, 1000);
        }
    };

    // Função para fazer scroll horizontal do link ativo para dentro da área visível
    const scrollActiveLinkIntoView = () => {
        const activeLink = document.querySelector('.procampo-internal-nav .nav-link.active');
        const navLinksContainer = document.getElementById('nav-links-container');
        
        if (activeLink && navLinksContainer) {
            // Calcula a posição do link ativo em relação ao container
            const containerRect = navLinksContainer.getBoundingClientRect();
            const linkRect = activeLink.getBoundingClientRect();
            
            // Calcula a posição relativa do link dentro do container
            const linkLeftRelative = linkRect.left - containerRect.left + navLinksContainer.scrollLeft;
            const linkRightRelative = linkLeftRelative + linkRect.width;
            const containerWidth = containerRect.width;
            const scrollLeft = navLinksContainer.scrollLeft;
            
            // Verifica se o link está completamente visível
            const isFullyVisible = linkLeftRelative >= scrollLeft && 
                                   linkRightRelative <= scrollLeft + containerWidth;
            
            if (!isFullyVisible) {
                // Calcula a posição de scroll para centralizar o link
                const scrollTarget = linkLeftRelative - (containerWidth / 2) + (linkRect.width / 2);
                
                // Faz scroll suave para mostrar o link ativo centralizado
                navLinksContainer.scrollTo({
                    left: Math.max(0, scrollTarget),
                    behavior: 'smooth'
                });
            }
        }
    };

    // Função para marcar um link como ativo (por data-section) e centralizá-lo na área visível
    const setActiveSection = (sectionId) => {
        const navLinks = document.querySelectorAll('.procampo-internal-nav .nav-link');
        navLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('data-section') === sectionId) {
                link.classList.add('active');
            }
        });
        setTimeout(() => scrollActiveLinkIntoView(), 100);
    };

    // Função para atualizar o link ativo baseado no scroll
    const updateActiveLink = () => {
        // Durante o scroll suave disparado por um clique, o link ativo já foi
        // definido imediatamente em scrollToSection - não recalcular por posição
        if (isProgrammaticScroll) return;

        const navElement = document.querySelector('.procampo-internal-nav');
        if (!navElement) return;

        const navHeight = navElement.offsetHeight || 0;
        const headerHeight = 135; // altura do header principal
        // Offset total: header + navegação + margem de segurança
        const offsetThreshold = headerHeight + navHeight + 50;

        // Se estamos no topo da página, marca "inicio" como ativo
        if (window.scrollY < 100) {
            setActiveSection('inicio');
            return;
        }

        let currentSection = 'inicio';
        let bestSection = null;
        let bestDistance = Infinity;

        // Percorre todas as seções para encontrar a que está mais próxima do threshold
        sectionIds.forEach(sectionId => {
            const section = document.getElementById(sectionId);
            if (!section) return;

            const rect = section.getBoundingClientRect();
            
            // Calcula a distância do topo da seção até o threshold
            const distanceFromThreshold = Math.abs(rect.top - offsetThreshold);
            
            // Se a seção está visível no viewport
            if (rect.bottom > 0) {
                // Prioriza seções que já passaram pelo threshold (topo acima do threshold)
                // mas ainda estão visíveis
                if (rect.top <= offsetThreshold) {
                    // Seção já passou pelo threshold
                    if (distanceFromThreshold < bestDistance) {
                        bestDistance = distanceFromThreshold;
                        bestSection = sectionId;
                    }
                } else if (rect.top > offsetThreshold && rect.top < offsetThreshold + 300) {
                    // Seção está abaixo do threshold mas próxima
                    // Só considera se ainda não encontramos uma que passou
                    if (!bestSection && distanceFromThreshold < bestDistance) {
                        bestDistance = distanceFromThreshold;
                        bestSection = sectionId;
                    }
                }
            }
        });

        // Se encontrou uma seção, usa ela
        if (bestSection) {
            currentSection = bestSection;
        }

        setActiveSection(currentSection);
    };

    // Scroll suave para as seções ao clicar nos links
    const navLinks = document.querySelectorAll('.procampo-internal-nav .nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            // Verifica se é uma seção válida (não é quero-ser-pro)
            if (sectionIds.includes(targetId)) {
                scrollToSection(targetId);
            }
        });
    });

    // Navegação com setas (próxima/anterior seção)
    const scrollLeftBtn = document.getElementById('nav-scroll-left');
    const scrollRightBtn = document.getElementById('nav-scroll-right');

    if (scrollLeftBtn && scrollRightBtn) {
        // Função para obter a seção atual ativa
        const getCurrentActiveSection = () => {
            const activeLink = document.querySelector('.procampo-internal-nav .nav-link.active');
            if (activeLink) {
                return activeLink.getAttribute('data-section');
            }
            return 'inicio';
        };

        // Função para navegar para a seção anterior
        scrollLeftBtn.addEventListener('click', () => {
            const currentSection = getCurrentActiveSection();
            const currentIndex = sectionIds.indexOf(currentSection);
            
            if (currentIndex > 0) {
                const previousSection = sectionIds[currentIndex - 1];
                scrollToSection(previousSection);
            }
        });

        // Função para navegar para a próxima seção
        scrollRightBtn.addEventListener('click', () => {
            const currentSection = getCurrentActiveSection();
            const currentIndex = sectionIds.indexOf(currentSection);
            
            if (currentIndex < sectionIds.length - 1) {
                const nextSection = sectionIds[currentIndex + 1];
                scrollToSection(nextSection);
            }
        });
    }

    // Função para atualizar a posição da navegação baseado no scroll
    const updateNavPosition = () => {
        const navElement = document.querySelector('.procampo-internal-nav');
        const headerElement = document.getElementById('main-header');
        if (navElement) {
            // Se o scroll for maior que 50px, adiciona a classe 'scrolled' e esconde o header principal
            if (window.scrollY > 50) {
                navElement.classList.add('scrolled');
                headerElement?.classList.add('header-hidden');
            } else {
                navElement.classList.remove('scrolled');
                headerElement?.classList.remove('header-hidden');
            }
        }
    };

    // Atualizar link ativo durante o scroll
    let ticking = false;
    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateActiveLink();
                updateNavPosition();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    updateActiveLink(); // Inicializar
    updateNavPosition(); // Inicializar posição da navegação
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
} else {
    initialize();
}
